// Dr. Mavroson's care team — copy and photos from fuscocare.com/about-us (the
// practice's own page). Bios are trimmed, not rewritten. Shared by every
// concierge program; each passes the question id each slide follows.
const TEAM_SOURCE = 'Fusco Care Services · fuscocare.com';

export const CARE_TEAM = {
  michael: {
    id: 'ix-team-michael', kind: 'team', plain: 'Meet', accent: 'your care team.',
    name: 'Michael Fusco, PA-C', role: 'Board-certified Physician Associate · New York', photo: '/programs/team/michael-fusco.png', source: TEAM_SOURCE,
    bio: [
      'Michael is a board-certified Physician Associate with expertise in internal medicine and emergency care, focused on diagnosing, treating and managing acute and chronic conditions.',
      'He earned his Master’s in Physician Assistant Studies from Hofstra University and a B.S. in Exercise Science from Adelphi University (magna cum laude), and has practiced with Montefiore Medical Center and Summit Health/CityMD in primary and emergency care.',
    ],
  },
  valerie: {
    id: 'ix-team-valerie', kind: 'team', plain: 'Your nurse,', accent: 'Valerie.',
    name: 'Valerie Craft-Drago, RN', role: 'Registered Nurse · ICU & integrative care', photo: '/programs/team/valerie-craft-drago.png', source: TEAM_SOURCE,
    bio: [
      'A lifelong gymnast and former USAG level 10 competitor, Valerie came to healthcare through her own recovery from lumbar disc injuries with holistic therapies instead of surgery.',
      'She graduated summa cum laude from Stony Brook University in Health Science (Emergency Critical Care) and earned her B.S. in Nursing with highest honors, and works in the ICU. She combines medical expertise with an integrative, Eastern-and-Western approach to long-term health.',
    ],
  },
  madison: {
    id: 'ix-team-madison', kind: 'team', plain: 'Your nurse,', accent: 'Madison.',
    name: 'Madison Schwarz, RN', role: 'Registered Nurse · Emergency Department', photo: '/programs/team/madison-schwarz.png', source: TEAM_SOURCE,
    bio: [
      'Madison believes compassionate, patient-centered care is as important as the treatment itself, and that healthcare should promote wellness and empower people to take an active role in their health.',
      'She graduated with highest honors from Stony Brook University in Health Science (Emergency and Critical Care), completed its Accelerated Baccalaureate Nursing Program, and cares for patients in the Emergency Department at Stony Brook University Hospital.',
    ],
  },
};

// { michael: '<question id>', valerie: '<question id>', madison: '<question id>' }
export const CARE_TEAM_SLIDES = (after) =>
  Object.keys(CARE_TEAM).filter((k) => after[k]).map((k) => ({ ...CARE_TEAM[k], after: after[k] }));
